
import React, { useEffect, useState } from 'react';
import { Helmet } from "react-helmet";
import {
    Link,
} from "react-router-dom";
import { NavHashLink } from 'react-router-hash-link';

import appScreenshot from '../../assets/images/payroll.png';

import { connect } from 'react-redux';
import { Actions as CREATEACCOUNTACTIONS } from 'store/actions/createAccountActions';
import { Actions as WEBINARACTIONS } from 'store/actions/webinarActions';
// import {Actions as TEAMACTIONS} from './store/actions/teamActions';
// import {Actions as AUTHENTICATIONACTIONS} from './store/actions/authenticationActions';
import RegistrationForm from 'components/common/RegistrationForm'
import FeaturesSideBySide from 'components/features/FeaturesSideBySide'
import UkFeatures from 'components/features/UkFeatures'
import Team from 'components/team/Team'
import Pricing from 'components/pricing/PricingUk'
import Testimonials from 'components/testimonials/Testimonials'
import Security from 'components/security/Security'

import { format, addMinutes } from "date-fns";

import Vimeo from '@u-wave/react-vimeo';
import ReactPixel from 'react-facebook-pixel';
// import AddToCalendar from 'react-add-to-calendar';
import AddToCalendarHOC from 'react-add-to-calendar-hoc';

import 'react-add-to-calendar/dist/react-add-to-calendar.css'
import { CheckIcon, XMarkIcon } from '@heroicons/react/24/outline'

import { Disclosure } from '@headlessui/react'
import { ChevronDownIcon } from '@heroicons/react/24/outline'

function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
}

const EMAILLIST = 11
const tags = {
    ukSignUp: 56
}

const title = "Discover Buddy your new Payroll Campanion",
    intro = "Buddy will be available to the general public in April 2024; however, you can get early access to Buddy's UK Payroll Software by signing up today. Integrations with HMRC and leading Accounting, Pensions and Payment platforms are readily available.",
    description = "UK Payroll has never been easier. With Buddy's cloud UK Payroll Software, you can get payroll done quickly and efficiently."
// intro: "Rediscover the Joy of Payroll",


const painpoints = [
    {
        name: 'Payroll Errors',
        description: 'Having payroll issues noted by yourself or staff, just because nothing talks to each other',
    },
    {
        name: 'Slow Legacy Systems',
        description: 'Software that works only on a single computer or takes forever to help you get your job done.',
    },
    {
        name: 'Printing Payslips',
        description: 'Handing out hard-copy Payslips to employees, risking employees get their hand on the wrong slip',
    },
    {
        name: 'Making tons of interventions',
        description: 'Having to manually update, hours worked, overtime and other adjustments.',
    },
]

const notfor = [
    "Employers who don't have a clue what they pay their employees",
    "Business Professionals who are happy to spend time on low-value tasks",
    "Business Professionals who don't care if salaries are issued correctly",
    "Business Professionals would rather slave themselves at night or on weekends instead of spending time with their loved ones",
]

const faqs = [
    {
        question: "I'm a Service Provider, can I use Buddy to provide payroll to clients?",
        answer:
            "Great question, yes, you can use Buddy to provide payroll services to your customer. We do offer special service provider features that enable you to provide your customer with dedicated client and employee portals to facilitate the payroll process as much as possible. You can visit our dedicated pages for service providers, for more details or setup a time to talk to our team.",
    },
    {
        question: "Do I need to be a payroll expert to use Buddy?",
        answer:
            "We understand that not every business professional is well versed in payroll. Hence we made sure, that wherever possible to software is guiding you to make sure you do payroll like a pro. We had clients who tought that they wouldn't be able to do payroll, as it seemed too complex, however they realised that if they were able to use social media, doing payroll wasn't such a big jump after all.",
    },
    {
        question: "Do you offer support and how does it work?",
        answer:
            "Support is a key part of any payroll software, it is critical that you find the right assistance whenever you need it. As we understand that payroll is mission-critical, we offer FREE chat and email support to help you on any queries that you may have when using our payroll solution. However, we do also provide detailed online userguides and certification courses to ensure you can proceed swiftly through payroll. We do have higher tier support packages, that include phone support and extended business hours.",
    },
    {
        question: "Do you offer onboarding and migration assistance?",
        answer:
            "While our software is easy enough that you should be able to get started without assistance, we understand that not every business may have the necessary resources and time to migrate their data. Hence we do offer optional on-boarding and training, reach out to our team so we can understand your requirements in more details.",
    },
    // More questions...
]

function UkDemo({
    userInList,
    contactInList,
    saveLead,
    profile,
    partner,
}) {

    useEffect(() => {
        // load initial data required for anywhere
        if (profile && profile.email) {
            contactInList({
                email: profile.email,
                // list: EMAILLIST
            })
        }
    }, [profile && profile.email]);


    return (

        <React.Fragment>
            <Helmet>
                <title>{title}</title>
                <meta name="description" content={intro} />
                <link rel="canonical" href={`https://www.buddy.hr/uk/beta`} />
                <html lang="en-GB" amp />
                <link rel="alternate" href="https://www.buddy.hr" hrefLang="en-MT" />
            </Helmet>
            <main className="mt-8 sm:mt-16 md:mt-20 lg:mb-24 mb-8 sm:mb-16 md:mb-20 lg:mb-24">
                <div className="mx-auto max-w-screen-xl">
                    <div className="lg:grid lg:grid-cols-12 lg:gap-8">
                        <div className="px-4 sm:px-6 sm:text-center md:max-w-2xl md:mx-auto lg:col-span-6 lg:text-left lg:flex lg:items-center">
                            <div>
                                {/*<Link to="/" className="inline-flex items-center text-white bg-gray-900 rounded-full p-1 pr-2 sm:text-base lg:text-sm xl:text-base hover:text-gray-200">
                                  <span className="px-3 py-0.5 text-white text-xs font-semibold leading-5 uppercase tracking-wide bg-orange-500 rounded-full">Malta Edition</span>
                                  <span className="ml-4 text-sm leading-5">Click to discover payroll in other countries</span>
                                  
                                  <svg className="ml-2 w-5 h-5 text-gray-500" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                                    <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clipRule="evenodd" />
                                  </svg>
                                </Link>*/}
                                <h1 className="mt-4 text-4xl tracking-tight leading-10 font-extrabold text-white sm:mt-5 sm:leading-none sm:text-6xl lg:mt-6 lg:text-5xl xl:text-6xl">
                                    {profile.givenName ?
                                        <>
                                            <span className="text-4xl sm:text-4xl lg:text-5xl xl:text-6xl">Hey {profile.givenName},</span><br />
                                        </>
                                        : ``}
                                    <span className="text-3xl sm:text-3xl lg:text-4xl xl:text-5xl">Be the first.</span>
                                    <br />
                                    <span className="text-orange-400">Try Buddy Today</span>
                                    <br />
                                    <span className="text-3xl sm:text-3xl lg:text-4xl xl:text-5xl">join our </span>
                                    <span className="text-orange-400"> exclusive </span>
                                    <br />
                                </h1>
                                    <span className="text-2xl sm:text-2xl lg:text-3xl xl:text-4xl tracking-tight leading-10
font-extrabold text-white sm:mt-5 sm:leading-none">early-access programme.</span>
                                <p className="mt-3 text-base text-gray-300 sm:mt-5 sm:text-md lg:text-md xl:text-lg">
                                    {intro}
                                </p>
                                {/*<p className="mt-8 text-sm text-white uppercase tracking-wide font-semibold sm:mt-10">Used by</p>
                <div className="mt-5 w-full sm:mx-auto sm:max-w-lg lg:ml-0">
                  <div className="flex flex-wrap items-start justify-between">
                    <div className="flex justify-center px-1">
                      <img className="h-9 sm:h-10" src={mcDonaldsLogo} alt="Mc Donalds"/>
                    </div>
                    <div className="flex justify-center px-1">
                      <img className="h-9 sm:h-10" src={myokaLogo} alt="Myoka Spas"/>
                    </div>
                    <div className="flex justify-center px-1">
                      <img className="h-9 sm:h-10" src={skySpiritLogo} alt="Sky Spirit"/>
                    </div>
                  </div>
                </div>*/}
                            </div>
                        </div>
                        
                        <div className="mt-12 sm:mt-16 lg:mt-0 lg:col-span-6">
                          <RegistrationForm jurisdiction="UK" partner={partner} list={EMAILLIST} leadOnly={true} />
                        </div>
                    </div>
                </div>
            </main>


            <div className="bg-orange-600">
                <div className="max-w-2xl mx-auto text-center py-16 px-4 sm:py-20 sm:px-6 lg:px-8">
                    <h2 className="text-3xl leading-9 font-extrabold text-white sm:text-4xl sm:leading-10">
                        <span className="block">Want to speak to someone?</span>
                        <span className="block">Book a call with an expert.</span>
                    </h2>
                    <a target="_blank" href="https://calendly.com/buddy-intro/uk" className="mt-8 w-full inline-flex items-center justify-center px-5 py-3 border border-transparent text-base leading-6 font-medium rounded-md text-orange-600 bg-white hover:text-orange-500 hover:bg-orange-50 transition duration-150 ease-in-out sm:w-auto">
                        Book my spot
                    </a>
                    <p className="mt-4 text-xs leading-1 text-orange-200">We'll take 15min of your time to understand if you're someone our payroll solution can help. <br /> This is a no-commitment call and comes at no charge.</p>
                </div>
            </div>


        </React.Fragment>

    );
}

const mapStateToProps = (state) => {

    // const {
    //   myAgreements,
    // } = state.my

    let profile = state && state.my && state.my.profile //|| localStorage.getItem('userData') && JSON.parse(localStorage.getItem('userData'))

    let partner = false
      if (!profile){
        // check if we have url params in the request
        const urlParams = new URLSearchParams(window.location.search);
        const email = urlParams.get('email');
        const givenName = urlParams.get('givenName');
        const familyName = urlParams.get('familyName');
        const organisation = urlParams.get('name');
        partner = urlParams.get('partner') ? true : false;
        profile = {
          isPreloaded: true,
          email,
          givenName,
          familyName,
          organisation
        }
      }

    const userInList = state.createAccount && state.createAccount.inList && state.createAccount.inList.find(item => item == EMAILLIST)

    const webinar = state.webinar

    const userSubscribedForWebinar = webinar && state.createAccount && state.createAccount.webinars && state.createAccount.webinars.find(item => item == webinar.webinarID)


    return {
        webinar,
        userInList,
        userSubscribedForWebinar,
        profile,
        partner
        // showSidebar: state.sidebar.show,
        // loggedIn: state.my.profile ? true : false,
    }
}

const mapDispatchToProps = dispatch => ({
    contactInList: (data) => dispatch(CREATEACCOUNTACTIONS.contactInList(data)),
    saveLead: (data) => dispatch(CREATEACCOUNTACTIONS.saveLead(data)),
    addTag: (data) => dispatch(CREATEACCOUNTACTIONS.addTag(data)),
    setWebinar: (webinar) => dispatch(WEBINARACTIONS.setWebinar(webinar)),
    // getProfile: () => dispatch(MYACTIONS.getProfile()),
    // isLoggedIn: () => dispatch(AUTHENTICATIONACTIONS.isLoggedIn()),
    // getDepartments: () => dispatch(TEAMACTIONS.getDepartments()),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(UkDemo) 